// extracted by mini-css-extract-plugin
export default {"createSakMain":"createSak_createSakMain__VFLNw"};